import { render, staticRenderFns } from "./NucleoIcons.vue?vue&type=template&id=79fcf1cc"
import script from "./NucleoIcons.vue?vue&type=script&lang=js"
export * from "./NucleoIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports